import { z } from 'zod';
import { normalizePhone } from '../phone.js';

/** A phone typed by a person, normalized to E.164 (fails with the normalizer's reason). */
export const PhoneInputSchema = z.string().transform((value, ctx) => {
  const r = normalizePhone(value);
  if (!r.ok) {
    ctx.addIssue({ code: 'custom', message: r.reason });
    return z.NEVER;
  }
  return r.e164;
});

/** New merchant form: the phone and the assigned rep. Field values are checked per field. */
export const NewMerchantSchema = z.object({
  phone: PhoneInputSchema,
  assignedRepId: z.uuid({ error: 'Choose who this merchant is assigned to' }),
});
export type NewMerchant = z.infer<typeof NewMerchantSchema>;
